<template>
  <div id="sig-container" class="block full form-horizontal">
    <div class="widget">
      <div class="widget-content widget-content-mini themed-background-dark-default text-light">
        <span class="float-right text-muted">
          <span class="float-right text-muted">
            <button @click="$router.go(-1)" class="btn btn-xs btn-primary">Volver</button>
            <span class="mx-2">|</span>
            <button @click="irConsulta" class="btn btn-xs btn-primary">Gestionar</button>
          </span>
        </span>
        Detalle de la consulta
      </div>
    </div>

    <div class="row">
      <!-- Columna para la tarjeta -->
      <div class="col-md-3">
        <h5 class="card-title mb-2">Información basica</h5>
        <div class="loader" v-if="loading">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <div class="card mb-3 shadow-sm">
          <div class="card-body">
            <h5 class="card-title mb-2">{{ nombre }}</h5>
            <h6 class="card-subtitle mb-3">Cédula: {{ cedula }}</h6>

            <ul class="list-group list-group-flush mb-3">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                v-if="total_operaciones > 0">
                Total de operaciones
                <span class="badge bg-primary rounded-pill">{{ total_operaciones }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center" v-if="total_vigentes > 0">
                Operaciones vigentes
                <span class="badge bg-success rounded-pill">{{ total_vigentes }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center" v-if="total_pagadas > 0">
                Operaciones pagadas
                <span class="badge bg-info rounded-pill">{{ total_pagadas }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center"
                v-if="total_proceso_pago > 0">
                Operaciones en proceso de pago
                <span class="badge bg-warning text-dark rounded-pill">{{ total_proceso_pago }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center"
                v-if="total_recuperacion > 0">
                Operaciones recuperadas o en proceso de recuperación
                <span class="badge bg-secondary rounded-pill">{{ total_recuperacion }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center" v-if="total_canceladas > 0">
                Operaciones canceladas
                <span class="badge bg-danger rounded-pill">{{ total_canceladas }}</span>
              </li>
            </ul>

            <!-- Botón para mostrar/ocultar las notas -->
            <button class="btn btn-sm btn-outline-secondary w-100" @click="mostrarNotas = !mostrarNotas">
              {{ mostrarNotas ? 'Ocultar notas' : 'Ver notas' }}
            </button>

            <!-- Notas ocultables -->
            <transition name="fade">
              <div v-if="mostrarNotas" class="mt-3">
                <h5 class="">Notas / Descripción</h5>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    <strong>Total de operaciones:</strong> Corresponde al número total de operaciones registradas para
                    el titular consultado.
                  </li>
                  <li class="list-group-item">
                    <strong>Operaciones vigentes:</strong> Son aquellas que actualmente están vigentes y no presentan
                    liquidación ni cancelación.
                  </li>
                  <li class="list-group-item">
                    <strong>Pagadas o en proceso de pago:</strong> Incluye operaciones liquidadas o en proceso de
                    liquidación.
                  </li>
                  <li class="list-group-item">
                    <strong>Recuperadas:</strong> Operaciones que fueron o están siendo recuperadas actualmente.
                  </li>
                  <li class="list-group-item">
                    <strong>Canceladas:</strong> Finalizadas por cumplimiento, cancelación anticipada o decisión
                    administrativa.
                  </li>
                </ul>
              </div>
            </transition>

          </div>
        </div>
      </div>

      <!-- Columna para la tabla -->
      <div class="col-md-9">
        <h5 class="card-title mb-2">Filtros</h5>
        <div class="col-lg-9 col-md-9">
          <div class="row mb-3 align-items-center">
            <label for="estado_garantia" class="col-sm-2 col-form-label">
              Intermediario
            </label>
            <div class="col-sm-4">
              <select class="form-control" id="intermediario" v-model="filtros.intermediario">
                <option :value="null">Todos</option>
                <option v-for="intermediario in intermediarios" :key="intermediario.valor" :value="intermediario.valor">
                  {{ intermediario.valor }}
                </option>
              </select>
            </div>
            <label for="estado_garantia" class="col-sm-2 col-form-label">
              Estado garantía
            </label>
            <div class="col-sm-4">
              <select class="form-control" id="estado_garantia" v-model="filtros.tipo">
                <option :value="null">Todos</option>
                <option v-for="tipo in tipos" :key="tipo.valor" :value="tipo.valor">
                  {{ tipo.valor }}
                </option>
              </select>
            </div>


          </div>
          <div class="row mb-3 align-items-center">

            <label for="estado_pago" class="col-sm-2 col-form-label">
              Estado de pago
            </label>
            <div class="col-sm-4">
              <select class="form-control" id="estado_pago" v-model="filtros.tipo_pago">
                <option :value="null">Todos</option>
                <option v-for="tipo_pago in tipos_pagos" :key="tipo_pago.valor" :value="tipo_pago.valor">
                  {{ tipo_pago.valor }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <br />
        <h5 class="card-title mb-2">Listado de operaciones</h5>
        <div>
          <div class="loader" v-if="loading">
            <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
          </div>
          <table-component :key="tableKey" :data="data" :perPage="6">
            <table-column slot="label" :label="'Intermediario'" v-bind:value="'nombre_abr'"></table-column>
            <table-column slot="label" :label="'Nit'" v-bind:value="'nit'"></table-column>
            <table-column slot="label" :label="'Pagare'" v-bind:value="'pagare'"></table-column>
            <table-column slot="label" :label="'Estado de la garantia'" v-bind:value="'estado_garantia'"></table-column>
            <table-column slot="label" :label="'Estado del pago'" v-bind:value="'estado_pago'"></table-column>
            <table-column slot="label" :label="'Fecha de pago'" v-bind:value="'fecha_pago'"></table-column>
            <table-column slot="label" :label="'Estado de la notificacion'"
              v-bind:value="'estado_notificacion'"></table-column>
            <table-column slot="label" :label="'Tipo recuperacion'" v-bind:value="'tipo_recuperacion'"></table-column>
          </table-component>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import { watch } from "vue";
import { mapGetters } from "vuex";

export default {
  name: "Gestiones",
  data: () => {
    return {
      datos: [],
      datos_filter: [],
      nombre: "Sin información",
      cedula: "N/A",
      total_operaciones: 0,
      total_vigentes: 0,
      total_pagadas: 0,
      total_proceso_pago: 0,
      total_recuperacion: 0,
      total_canceladas: 0,
      mostrarNotas: false,
      paginacion: {
        page: 1
      },
      filtros: {
        tipo: null,
        tipo_pago: null,
        intermediario: null
      }
    };
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({ loading: "loading" }),
    data() {
      return ((this.filtros.tipo !== null || this.filtros.tipo_pago !== null || this.filtros.intermediario !== null) ? this.datos_filter : this.datos);
    },
    intermediarios() {
      if (this.datos_filter.length > 0) {
        return [...new Set(this.datos_filter.map(item => item.nombre_abr))].map(intermediario => ({
          "valor": intermediario,
          "label": intermediario
        }));
      } else {
        return [...new Set(this.datos.map(item => item.nombre_abr))].map(intermediario => ({
          "valor": intermediario,
          "label": intermediario
        }));
      }
    },
    tipos() {
      if (this.datos_filter.length > 0) {
        return [...new Set(this.datos_filter.map(item => item.estado_garantia))].map(tipo => ({
          "valor": tipo,
          "label": tipo
        }));
      } else {
        return [...new Set(this.datos.map(item => item.estado_garantia))].map(tipo => ({
          "valor": tipo,
          "label": tipo
        }));
      }
    },
    tipos_pagos() {
      if (this.datos_filter.length > 0) {
        return [...new Set(this.datos_filter.map(item => item.estado_pago))].map(tipo_pago => ({
          "valor": tipo_pago,
          "label": tipo_pago
        }));
      } else {
        return [...new Set(this.datos.map(item => item.estado_pago))].map(tipo_pago => ({
          "valor": tipo_pago,
          "label": tipo_pago
        }));
      }
    },
    // Fuerza que el TableComponent se reinicialice con page=1 al cambiar filtros
    tableKey() {
      return JSON.stringify(this.filtros);
    }
  },
  methods: {
    getData(documento) {
      this.datos = [];
      this.$store.dispatch("index", {
        endpoint: "ampliar_informacion",
        params: { documento: documento },
      })
        .then((response) => {
          this.datos = response.datos;
          this.nombre = response.datos[0].nombre;
          this.cedula = response.datos[0].cedula;
          this.total_operaciones = response.paginacion.total;
          this.total_vigentes = response.total_vigentes;
          this.total_pagadas = response.total_pagadas;
          this.total_proceso_pago = response.total_proceso_pago;
          this.total_recuperacion = response.total_recuperacion;
          this.total_canceladas = response.total_canceladas;
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
    irConsulta() {
      this.$router.push({ path: "/informacion-contacto/" + this.$route.params.documento });
    }
  },
  watch: {
    filtros: {
      handler(newValue, oldValue) {
        this.paginacion.page = 1;
        if (newValue.intermediario == null && newValue.tipo == null && newValue.tipo_pago == null) {
          this.datos_filter = [];
        } else {
          if (this.datos_filter.length > 0) {
            if (newValue.tipo && newValue.tipo_pago) {
              this.datos_filter = this.datos_filter.filter(item => item.estado_garantia === newValue.tipo && item.estado_pago === newValue.tipo_pago);
            } else if (newValue.tipo) {
              this.datos_filter = this.datos_filter.filter(item => item.estado_garantia === newValue.tipo);
            } else if (newValue.tipo_pago) {
              this.datos_filter = this.datos_filter.filter(item => item.estado_pago === newValue.tipo_pago);
            } else if (newValue.intermediario) {
              this.datos_filter = this.datos_filter.filter(item => item.nombre_abr === newValue.intermediario);
            }
          } else {
            if (newValue.tipo && newValue.tipo_pago) {
              this.datos_filter = this.datos.filter(item => item.estado_garantia === newValue.tipo && item.estado_pago === newValue.tipo_pago);
            } else if (newValue.tipo) {
              this.datos_filter = this.datos.filter(item => item.estado_garantia === newValue.tipo);
            } else if (newValue.tipo_pago) {
              this.datos_filter = this.datos.filter(item => item.estado_pago === newValue.tipo_pago);
            } else if (newValue.intermediario) {
              this.datos_filter = this.datos.filter(item => item.nombre_abr === newValue.intermediario);
            }
          }
        }

      },
      deep: true
    }
  },
  mounted() {
    this.getData(this.$route.params.documento);
  },
};
</script>
<style>
#space {
  padding-top: 10px;
}

#datepicker {
  background: white;
  padding-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.disponibles {
  display: flow-root !important;
}

.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}

.table thead>tr>th {
  font-size: 14px !important;
}

.table thead>tr>td {
  font-size: 10px !important;
}

.table-responsive {
  overflow: auto !important;
  width: 100%;
}
</style>
